<ng-container *transloco="let t">
  <div>
    <div class="mb-4">
      <ISelectMenu [(value)]="selectedOrganization" by="id" fitTriggerWidth [(searchQuery)]="searchQuery">
        <ISelectTrigger class="flex w-full">
          <ISelectValue placeholder="Select an organization">
            <div *iSelectValue="let value">{{ value?.organizationName }}</div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          @for (organization of filteredOrganizations(); track organization.id) {
            <ISelectOption [value]="organization">
              {{ organization.organizationName }}
            </ISelectOption>
          }
        </ISelectContent>
      </ISelectMenu>
    </div>
    @if (isEmailRegistered() === false && email.valid) {
      <div class="mb-4">
        <IAlert [title]="t('manage-authorized-access-modal.email_description')" />
      </div>
    }
    <form id="email-form" name="email-form" [formGroup]="emailForm">
      <IFormField>
        <label iLabel>{{ t("common.email") }}</label>
        <input iInput placeholder="email@example.com" [formControl]="emailForm.controls.email" size="sm" autoFocus />
        <IError>{{ t("register.email_invalid_error") }}</IError>
      </IFormField>
    </form>
    <div class="flex justify-end gap-2 pt-4">
      <button iButton variant="secondary" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
      <button
        iButton
        [loading]="checkEmailLoading() || addAdminLoading()"
        (click)="addAdmin()"
        [disabled]="email.invalid"
      >
        {{ buttonLabel() }}
      </button>
    </div>
  </div>
</ng-container>
